import { render, staticRenderFns } from "./SettingInboundCalls.vue?vue&type=template&id=612f3750&"
import script from "./SettingInboundCalls.vue?vue&type=script&lang=js&"
export * from "./SettingInboundCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports